import { PacmanLoader } from 'react-spinners';

import { styled } from '@lichtblick/styled';
import { Colors } from '@lichtblick/theme';

export const PacmanLoaderComponent = () => {
  return <PacmanLoader color={Colors.blue['100']} size={30} />;
};

const PacmanPanelRoot = styled.div<{ $background?: string }>`
  align-items: center;
  background: ${({ $background }) => $background ?? 'rgba(128, 128, 128, 0.08)'};
  display: flex;
  height: 100%;
  justify-content: center;
  min-height: 100%;
  width: 100%;
`;

type PacmanPanelLoaderProps = {
  background?: string;
};

export const PacmanPanelLoader = ({ background }: PacmanPanelLoaderProps) => {
  return (
    <PacmanPanelRoot $background={background}>
      <PacmanLoaderComponent />
    </PacmanPanelRoot>
  );
};
